import {
    type GetThreetTokenForMembersResponseType,
    type GetThreetTokenForMembersRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetThreetTokenForMembers = async (params: GetThreetTokenForMembersRequestType): Promise<GetThreetTokenForMembersResponseType> => {
    return await axios(`${SERVER_ADDRESS}/event/getThreetTokenForMembers`, {
        method: "GET",
        headers: getHeaders(true),
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetThreetTokenForMembers;
